export default "__VITE_ASSET__CAzuGcdP__"